/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';
// material
import Indicator from './indicator/indicator';
// styles
import injectSheet from 'react-jss';
import styles from './contentscroller_styles';



/* ========== ~~~~~~~~~~ CONTENT SCROLLER ~~~~~~~~~~ ========== */
const ContentScroller = injectSheet(styles)((props) => {
    return (
        <span className={`contentscroller ${props.classes.contentscroller}`}>
            <Indicator type={'backward'} />
            <span className={'showcase'}>
                {props.showcase}
            </span>
            <Indicator type={'forward'} />
        </span>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ContentScroller;
